export const ACCEPT_WELCOME_MESSAGE = "ACCEPT_WELCOME_MESSAGE";

interface AcceptWelcomeMessageAction {
    type: typeof ACCEPT_WELCOME_MESSAGE;
}

export type WelcomeMessageActions = AcceptWelcomeMessageAction;
